<template>
  <div class="main-wrapp">
    <!-- Google Tag Manager (noscript) -->
    <ClientOnly>
      <noscript><iframe title="Google Tag Manager" src="https://www.googletagmanager.com/ns.html?id=GTM-TM2CCD3X" height="0" width="0"
          style="display:none;visibility:hidden"></iframe></noscript>
    </ClientOnly>
    <!-- End Google Tag Manager (noscript) -->

    <Header />
    <div class="main-content">
      <NuxtPage />
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
const { t, locales, locale: currentLocale } = useI18n();
const route = useRoute();
const router = useRouter();
const { loadPagesForSeo } = useSeoStore()
const { pagesSeo } = storeToRefs(useSeoStore())

const currentLocaleIso = computed(() => {
  const current = locales.value.find(l => l.code === currentLocale.value);
  return (current as any)?.iso || 'en';
});

router.afterEach((v) => {
  if (v.query.afterApplication) console.log(v.query.afterApplication);
});

const getCanonicalUrl = (path: string) => {
  if (path === "/") return "https://smsbat.com/";
  const formattedPath = path.endsWith('/') ? path : `${path}/`;
  return `https://smsbat.com${formattedPath}`;
};

const generateLinks = () => {
  return [
    {
      rel: "canonical",
      href: getCanonicalUrl(route.path),
    },
  ];
};

loadPagesForSeo()

useHead({
  titleTemplate: () => t("seo.title"),
  meta: [
    { name: "description", content: () => t("seo.description") },
    { property: "og:locale", content: () => t("seo.langAndLocale") },
    { property: "og:type", content: "article" },
    {
      property: "og:title", content: () => {
        const seoData = pagesSeo.value.find(el => route.path.includes(el.route))
        return seoData?.seo?.layout?.title || t("seo.title")
      }
    },
    { property: "og:description", content: () => t("seo.description") },
    {
      property: "og:url",
      content: () => getCanonicalUrl(route.path),
    },
    { property: "og:site_name", content: "SMSBAT" },
    {
      property: "article:publisher",
      content: "https://www.facebook.com/smsbatcom",
    },
    { property: "article:modified_time", content: "2023-08-31T12:40:50+00:00" },
    {
      property: "og:image",
      content:
        "https://cdn-web.smsbat.com/uploads/2024/viber_bots.png",
    },
    { property: "og:image:type", content: "image/png" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@smsbatcom" },
  ],
  htmlAttrs: {
    lang: currentLocaleIso,
    dir: 'ltr'
  },
  link: () => [
    ...generateLinks(),
  ],
  script: [
    {
      innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-TM2CCD3X');`,
      type: 'text/javascript'
    }
  ]
});

onMounted(() => {
  if (document) {
    document.documentElement.lang = currentLocaleIso.value;
    document.documentElement.dir = 'ltr';
  }
});

watch(currentLocaleIso, (newIso) => {
  if (document) {
    document.documentElement.lang = newIso;
    document.documentElement.dir = 'ltr';
  }
});
</script>

<style lang="scss">
.main-wrapp {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1 1 auto;
  margin: 0 auto;
  width: 100%;
}
</style>
